import { render, staticRenderFns } from "./englishBox.vue?vue&type=template&id=150eebcc&scoped=true"
import script from "./englishBox.vue?vue&type=script&lang=js"
export * from "./englishBox.vue?vue&type=script&lang=js"
import style0 from "./englishBox.vue?vue&type=style&index=0&id=150eebcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150eebcc",
  null
  
)

export default component.exports